<template>
    <div>
        <div class="container-fluid mt-2 mb-5">
            <div class="row">
                <!-- Added patient details section -->
                <div class="col-md-12 mt-2">
                    <div class="row">
                        <div class="col-md-8">
                            <p>
                                <strong class="fw-bold">Nombre:</strong> {{ paciente?.nombre || 'No aplica' }} |
                                <strong class="fw-bold">Fecha de Nacimiento:</strong> {{ paciente?.fecha_nacimiento ?
                                formatDate(paciente.fecha_nacimiento) : 'No aplica' }} |
                                <strong class="fw-bold">Edad:</strong> {{ paciente?.fecha_nacimiento ?
                                calculateAge(paciente.fecha_nacimiento) : 'No calculada' }} <br>
                                <strong class="fw-bold">Género:</strong> {{ paciente?.genero || 'No aplica' }}
                                <strong class="fw-bold">Teléfono:</strong> {{ paciente?.telefono || 'No aplica' }} |
                                <strong class="fw-bold">Email:</strong> {{ paciente?.email || 'No aplica' }} |
                                <strong class="fw-bold">Dirección:</strong> {{ paciente?.direccion || 'No aplica' }} <br>
                                <strong class="fw-bold">Tiene Seguridad Social:</strong> {{ paciente?.tiene_seguridad_social ? 'Sí' : 'No' }} |
                                <strong class="fw-bold">Institución de Salud:</strong> {{ paciente?.institucion_salud || 'No aplica' }}
                            </p>
                        </div>
                        <div class="col-md-4 text-end">
                            <p>
                                <strong class="fw-bold">Fecha de consulta:</strong> {{ new
                                Date().toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric'
                                }) }}
                            </p>
                        </div>
                    </div>
                </div>
                <!-- Existing form section -->
                <div class="col-md-12  mb-3">
                    <div class="card">
                        <div class="card-body">
                            <p class="text-muted mt-2">Los campos marcados con <span class="text-danger">*</span> son
                                obligatorios.</p>
                                <div class="row">
                                    <div class="col-md-12 mb-3">
                                        <label class="form-label">Motivo de la Consulta <span
                                                class="text-danger">*</span></label>
                                        <textarea class="form-control" v-model.trim="nuevaConsulta.motivo"
                                            maxlength="250" required></textarea>
                                    </div>
                                    <div class="col-md-12 mb-3">
                                        <label class="form-label">Tipo de Consulta <span class="text-danger">*</span></label>
                                        <select class="form-control" v-model="nuevaConsulta.tipo_consulta" required>
                                            <option value="" disabled selected>Selecciona una opción</option>
                                            <option value="en consultorio">En consultorio</option>
                                            <option value="a domicilio">A domicilio</option>
                                            <option value="a hospital">A hospital</option>
                                            <option value="virtual">Virtual</option>
                                            <option value="extraordinaria">Extraordinaria</option>
                                            <option value="otra">Otra</option>
                                        </select>
                                    </div>
                                    <div class="col-md-12 mb-3">
                                        <label class="form-label">Origen de Consulta <span class="text-danger">*</span></label>
                                        <select class="form-control" v-model="nuevaConsulta.origen" required>
                                            <option value="" disabled selected>Selecciona una opción</option>
                                            <option value="recomendacion">Recomendación</option>
                                            <option value="whatsapp">WhatsApp</option>
                                            <option value="sitio web">Sitio Web</option>
                                            <option value="llamada telefonica">Llamada Telefónica</option>
                                            <option value="email">Email</option>
                                            <option value="redes sociales">Redes Sociales</option>
                                            <option value="otro">Otro</option>
                                            <option value="seguimiento">Seguimiento</option>
                                            <option value="consultorio">Consultorio</option>
                                        </select>
                                    </div>
                                    <hr class="mt-3"/>

                                    <div class="col-md-12 text-center">
                                        <vs-button type="submit" color="rgb(59,222,200)" gradient block @click="crearConsulta">
                                            Continuar 🚀
                                        </vs-button>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import SearchMedicamentos from './SearchMedicamentos.vue';
    var config = require("@/config/api.json");
    const API = config.api;

    export default {
        name: "Consulta",
        components: {
            SearchMedicamentos
        },
        props: {
            currentUser: {
                type: Object,
                required: true
            },
            paciente: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                nuevaConsulta: {
                    motivo:  this.paciente?.motivo, // Default value from paciente prop
                    origen: '', // Default value from paciente prop
                    tipo_consulta: '', // Default value
                    origen: '' // Default value from paciente prop
                },
            };
        },
        methods: {
            async crearConsulta() {
                if (!this.vEmpty(this.nuevaConsulta.motivo, 'Motivo de la Consulta')) return;
                if (!this.vEmpty(this.nuevaConsulta.origen, 'Origen de la Consulta')) return;
                if (!this.vEmpty(this.nuevaConsulta.tipo_consulta, 'Tipo de Consulta')) return;


                try {
                    const consultaData = {
                        ...this.nuevaConsulta,
                        paciente_id: this.paciente.id,
                        personal_medico_id: this.currentUser.mainId
                    };

                    const response = await axios.post(`${API}/crear_consulta_sin_cita`, consultaData);

                    if (response.data.status === 'success') {
                        this.notify('success', 'Consulta creada exitosamente');
                        this.resetForm();
                        console.log('ID:',response.data.consultaId);
                        this.$emit('terminaConsultaSinCita', response.data.consultaId);
                    }
                } catch (error) {
                    this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
                }
            },

            resetForm() {
                this.nuevaConsulta = {
                    motivo: '',
                    tipo_consulta: '',
                    origen: '',
                };
            },
            // Added formatDate method
            formatDate(date) {
                const options = { year: 'numeric', month: 'long', day: 'numeric' };
                return new Date(date).toLocaleDateString('es-ES', options);
            },
            calculateAge(dateOfBirth) {
                if (!dateOfBirth) return 'No calculado';
                const birthDate = new Date(dateOfBirth);
                const today = new Date();
                let age = today.getFullYear() - birthDate.getFullYear();
                const monthDiff = today.getMonth() - birthDate.getMonth();
                if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                    age--;
                }
                return `${age} años`;
            }
        }
    };
</script>

<style>
    /* Add any necessary styles here */
</style>